export const ADD_PROMO = "ADD_PROMO";
export const DE_ACTIVATE_PROMO = "DE_ACTIVATE_PROMO";
export const GET_PROMO = "GET_PROMO";
export const SET_PROMO = "SET_PROMO";


// WEBPACK FOOTER //
// ./src/components/promo/payment/actions/types.js